import React from "react";
import { RecoilRoot, useRecoilTransactionObserver_UNSTABLE } from "recoil";

import { accessTokenState, refreshTokenState } from "../recoil/auth";
import { noticeDetailState } from "../recoil/notice";
import { useSetRecoilState } from "recoil";
import { globalLoadingCountState } from "../recoil/ui";
import { registerGlobalLoadingSetter } from "../recoil/loadingController";

// localStorage에 저장할 atoms
const LOCAL_STORAGE_ATOMS = [accessTokenState, refreshTokenState];

// sessionStorage에 저장할 atoms
const SESSION_STORAGE_ATOMS = [noticeDetailState];

const initializeState = ({ set }) => {
  // localStorage에서 초기값 로드
  LOCAL_STORAGE_ATOMS.forEach((atom) => {
    const persistedState = localStorage.getItem(atom.key);
    if (persistedState) {
      try {
        const parsed = JSON.parse(persistedState);
        set(atom, parsed.value);
      } catch (error) {
        console.warn(`Failed to parse localStorage value for ${atom.key}:`, error);
      }
    }
  });

  // sessionStorage에서 초기값 로드
  SESSION_STORAGE_ATOMS.forEach((atom) => {
    const persistedState = sessionStorage.getItem(atom.key);
    if (persistedState) {
      try {
        const parsed = JSON.parse(persistedState);
        set(atom, parsed.value);
      } catch (error) {
        console.warn(`Failed to parse sessionStorage value for ${atom.key}:`, error);
      }
    }
  });
};

function PersistenceObserver() {
  useRecoilTransactionObserver_UNSTABLE(({ snapshot }) => {
    // 수정된 atoms를 가져옴
    for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
      const nodeLoadable = snapshot.getLoadable(node);

      // 로딩 중이거나 에러 상태가 아닌 경우에만 저장
      if (nodeLoadable.state === "hasValue") {
        const value = nodeLoadable.contents;
        const persistData = JSON.stringify({ value });

        // localStorage 저장 대상인지 확인
        if (LOCAL_STORAGE_ATOMS.includes(node)) {
          localStorage.setItem(node.key, persistData);
        }

        // sessionStorage 저장 대상인지 확인
        if (SESSION_STORAGE_ATOMS.includes(node)) {
          sessionStorage.setItem(node.key, persistData);
        }
      }
    }
  });
  return null;
}

const PersistentRecoil = ({ children }) => {
  return (
    <RecoilRoot initializeState={initializeState}>
      <PersistenceObserver />
      <RegisterLoadingSetter />
      {children}
    </RecoilRoot>
  );
};

export default PersistentRecoil;

function RegisterLoadingSetter() {
  const setLoadingCount = useSetRecoilState(globalLoadingCountState);
  React.useEffect(() => {
    registerGlobalLoadingSetter(setLoadingCount);
  }, [setLoadingCount]);
  return null;
}
